import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBase } from "mobx-stores/_models/base";
import { Product } from "mobx-stores/_models/products/product";

export const ProductGoodsReceiptItem = types
  .compose(
    Base,
    types.model({
      productId: types.maybeNull(types.string),
      product: types.maybeNull(Product),
      quantity: types.maybeNull(types.number),
      location: types.maybeNull(types.string),
      note: types.maybeNull(types.string),
    })
  )
  .actions(withSetPropAction);
export interface IProductGoodsReceiptItem
  extends Instance<typeof ProductGoodsReceiptItem> {}
export interface IProductGoodsReceiptItemProperties
  extends SnapshotIn<typeof ProductGoodsReceiptItem> {}

export interface IAddProductGoodsReceiptItem
  extends Omit<IProductGoodsReceiptItemProperties, "product" | keyof IBase> {}

export interface IUpdateProductGoodsReceiptItem
  extends Omit<IProductGoodsReceiptItemProperties, "product"> {}
